var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"风控记录","width":"90vw","visible":true,"close-on-click-modal":false,"close-on-press-escape":false,"before-close":function () { return _vm.$emit('close'); }}},[_c('table-render',{attrs:{"config":_vm.config,"prop-data":{
      query: { projectId: _vm.projectId }
    },"beforeInitPage":_vm.beforeInitPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }